import { __read, __spread } from "tslib";
import { useMemo } from 'react';
var getIsValidValue = function (value, min, max) {
    return !((typeof min === 'number' && value < min) || (typeof max === 'number' && value > max));
};
export var useSortSteps = function (props) {
    var step = props.step, min = props.min, max = props.max;
    var sortedSteps = useMemo(function () {
        if (Array.isArray(step)) {
            var stepsArr = __spread(step);
            if (typeof min === 'number') {
                stepsArr.push(min);
            }
            if (typeof max === 'number') {
                stepsArr.push(max);
            }
            var sortedArray = stepsArr
                .sort(function (a, b) { return a - b; })
                .filter(function (val) { return getIsValidValue(val, min, max); });
            return Array.from(new Set(sortedArray));
        }
        return Number(step);
    }, [step, min, max]);
    return sortedSteps;
};
